<template>
  <v-card class="ma-1 pa-2 tcard">
    <gat-form>
    <v-layout wrap>
      <gat-compact-field
        label="Date"
        :value="value.TRA_DATE"
        size="xs4 sm3 md2 lg2 xl1"
        isDate="true"
      />
      <gat-compact-field
        v-if="value.TRA_TYPE != 'Manual'"
        label="Amount"
        :value="formatCurrency(value.TRA_AMOUNT)"
        size="xs4 sm3 md2 lg2 xl1"
      />
      <gat-edit v-if="value.TRA_TYPE === 'Manual'" label="Amount" v-model="value.TRA_AMOUNT" size="xs4 sm3 md2 lg2 xl1" />
      <gat-compact-field
        label="Type"
        :value="value.TRA_TYPE"
        size="xs4 sm3 md2 lg2 xl1"
      />
      <gat-compact-field
        label="Description"
        :value="value.TRA_TEXT"
        size="xs12 sm9 md6 lg6 xl3"
      />
      <!-- <gat-flex size="xs12 md4"> <div class="ml-3 description">{{value.TRA_TXT}}</div></gat-flex> -->
      <gat-flex size="xs12 sm5 md4 lg3" class="pl-2">
        <v-layout wrap>
          <gat-flex size="xs11"
            ><category-select v-model="value.TRA_CAT_ID"
          /></gat-flex>
          <gat-flex size="xs1" class="pt-4 pl-2"
            ><rule-info
              v-model="value.rule"
              :transaction="value"
              :ruleMatchExecuted="ruleMatchExecuted"
            />
          </gat-flex>          
        </v-layout>
      </gat-flex>
      <!-- <gat-select label="Expected transaction"  v-if="getSelectedExpected" :value="getSelectedExpected" :items="expectedTransactions" textFieldName="text" codeFieldName="ID" @input="expectedWasSelected"  /> -->
      <gat-select label="Expected transaction"  v-if="expectedAmountExist" v-model="selectedExpectedId" :items="expectedTransactions" textFieldName="text" codeFieldName="ID" size="xs5" />
      <v-btn flat v-if="expectedAmountExist" @click="setSelect">Set</v-btn>
      <div></div>
      <gat-flex size="xs12" v-if="splitting">
        <splitter ref="splitterComponent" v-model="value" />
      </gat-flex>
      <gat-flex
        size="xs12 sm6 lg6"
        :class="{ 'pt-3': !$vuetify.breakpoint.xsOnly }"
      >
        <v-btn
          :class="{ right: $vuetify.breakpoint.xsOnly }"
          v-show="!saving"
          flat
          color="primary"
          @click="btnClicked"
          >Save</v-btn
        >
        <v-btn
          :class="{ righst: $vuetify.breakpoint.xsOnly }"
          v-show="!saving"
          flat
          @click="value.TRA_CAT_ID = 16"
          >Konto ovf</v-btn
        >
        <v-btn
          :class="{ righst: $vuetify.breakpoint.xsOnly }"
          v-show="!(saving || splitting)"
          flat
          @click="splitClicked"
          >Split</v-btn
        >
        <v-btn
          :class="{ righst: $vuetify.breakpoint.xsOnly }"
          v-show="splitting"
          flat
          @click="splitting = false"
          >Abort split</v-btn
        >
      </gat-flex>
    </v-layout>  
  </gat-form>  
  </v-card>
  
</template>

<script>
import GatCompactField from "@/GatComponents/GatCompactField.vue";
import GatEdit from "@/GatComponents/GatEdit.vue";
import GatFlex from "@/GatComponents/GatFlex.vue";
import CategorySelect from "@/components/CategorySelect.vue";
import RuleInfo from "@/components/RuleInfo.vue";
import Splitter from "@/components/Splitter.vue";
import GatForm from '../GatComponents/GatForm.vue';
import GatSelect from '../GatComponents/GatSelect.vue';
export default {
  name: "TransactionCard",
  props: ["value", "ruleMatchExecuted"],
  components: { GatCompactField, CategorySelect, GatFlex, RuleInfo, Splitter, GatEdit,GatForm, GatSelect},
  data: function () {
    return {
      category: null,
      btnText: "Ignore",
      saving: false,
      splitting: false,
      manualSelectedExpected: null,
      selectedExpectedId : null
    };
  },

  created() {
    this.category = this.value.TRA_CAT_ID;
  },

  watch: {
    value(newValue) {
      this.category = newValue.TRA_CAT_ID;
      this.saving = false;
    },
    // getSelectedExpected(newValue){
    //  if(newValue && newValue.CATEGORY_ID){
    //   this.value.TRA_CAT_ID = newValue.CATEGORY_ID;      
    //  }
    // },
    ruleMatchExecuted(newValue) {
      if (newValue) {
       this.setSelect(); 
      }
    },
  },

  computed:{
    expectedTransactions(){
      return this.$store.state.expectedTransactions.map(item=>{return {ID:item.ID,text:item.SUPPLIER+' | '+
      item.TRANSACTION_DATE.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }).replace(',', '') + ' | '+ item.AMOUNT.toFixed(2)+
            'kr | '+ item.DESCRIPTION}});
    },

    expectedAmountExist(){
      return this.$store.state.expectedTransactions.find(item=>item.AMOUNT == (this.value.TRA_AMOUNT*-1));
    },

  //   getSelectedExpected(){
  //     //use manualSelectedExpected if it is set
  //     if(this.manualSelectedExpected){
  //       return this.manualSelectedExpected;
  //     }
  //     const match = this.$store.state.expectedTransactions.find(item=>item.AMOUNT == (this.value.TRA_AMOUNT*-1));     
  //     return match;      
  //   }
  },

  methods: {
    btnClicked() {
      if (this.value.TRA_CAT_ID != null) {        
        this.saving = true;
        if(this.manualSelectedExpected){
          this.value.expectedTransId = this.selectedExpectedId;
        }
        
        if (this.splitting) {
          this.$refs.splitterComponent
            .save()
            .then(() => {
              this.$emit("save");
            })
            .catch(() => {
              this.saving = false;
            });
        } else {
          this.$emit("save");
        }
      }
    },

    expectedWasSelected(value){      
      this.manualSelectedExpected = this.$store.state.expectedTransactions.find(item=>item.ID == value);
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat("no-NO", {
        style: "currency",
        currency: "NOK",
      }).format(amount);
    },

    setSelect(){      
      const expectedMatch = this.$store.state.expectedTransactions.find(item=>item.AMOUNT == this.value.TRA_AMOUNT*-1);      
      if(expectedMatch){
        this.selectedExpectedId = expectedMatch.ID;
        this.value.TRA_CAT_ID = expectedMatch.CATEGORY_ID;    
      }      
      
    },

    splitClicked() {
      this.value.TRA_CAT_ID = 77;
      this.splitting = true;
    },
  },
};
</script>

<style scoped>
.tcard {
  /* max-width: 970px; */
}

.description {
  opacity: 0.7;
  font-size: 0.9em;
}
</style>
